import React from 'react';
import ImageData from "./ImageData.json";

const GetImage = (imagename) =>{
	return ImageData.filter(d => imagename == d.imagename).length > 0 ? `${ImageData.filter(d => imagename == d.imagename)[0].src}`:"";
}

export default GetImage;
